// store/permissionSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PermissionState {
  ManageCreateMeterV2: boolean;
  ManageEditMeterV2: boolean;
  ManageEditSparkmeter: boolean;
  ManageCreateSparkmeter: boolean;
  ManageActiveMeter: boolean;
  ManageArchiveMeter: boolean;
  ManageCreateMeterWip: boolean;
  BulkManageArchiveMeter: boolean;
  BulkManageActiveMeter: boolean;
  ManageBulkSMSUpload: boolean;
  ManageWarehouseMeter: boolean;
  ManageDeleteMeter:boolean,
  ManageExportOfflineMeterDetailsList: boolean;
  ManageDissociateMeterV2: boolean;
  ManageFMSDashboard: boolean;
  ManageDirectTariffPlanChange: boolean;
  nocIds: string[];
}

export const initialState: PermissionState = {
  ManageCreateMeterV2: false,
  ManageEditMeterV2: false,
  ManageEditSparkmeter: false,
  ManageCreateSparkmeter: false,
  ManageActiveMeter: false,
  ManageArchiveMeter: false,
  ManageCreateMeterWip: false,
  BulkManageArchiveMeter: false,
  BulkManageActiveMeter: false,
  ManageBulkSMSUpload: false,
  ManageWarehouseMeter: false,
  ManageDeleteMeter:false,
  ManageExportOfflineMeterDetailsList: false,
  ManageDissociateMeterV2: false,
  ManageFMSDashboard: false,
  ManageDirectTariffPlanChange: false,
  nocIds: [],
};

const permissionSlice = createSlice({
  name: 'permissions',
  initialState,
  reducers: {
    setPermissions: (state, action: PayloadAction<PermissionState>) => {
      return { ...state, ...action.payload };
    },
  },
});

export const { setPermissions } = permissionSlice.actions;
export default permissionSlice.reducer;
